/**
 * ============================================================
 * Popup Engine
 * MiningSurveyWebGIS
 * ============================================================
 */

import Feature from "./feature.js";

class Popup {
    /**
     * Bind Popup
     */
    bind(feature) {
        if (!feature) return;

        if (!feature.layer) return;

        feature.layer.bindPopup(
            this.build(feature),

            {
                maxWidth: 180,

                minWidth: 120,

                className: "elevation-popup",
            },
        );
    }

    /**
     * Build HTML
     */
    build(feature) {
        const elevation = Feature.getElevation(feature);

        return `
            <div class="popup-elevation">

                <div class="popup-title"><h3>
                    RL
                </h3></div>

                <div class="popup-value">

                    ${elevation === null ? "-" : Number(elevation).toFixed(0) + " m"}

                </div>

            </div>
        `;
    }

    /**
     * Update Popup
     */
    update(feature) {
        if (!feature) return;

        if (!feature.layer) return;

        feature.layer.setPopupContent(this.build(feature));
    }

    /**
     * Open
     */
    open(feature) {
        if (!feature) return;

        feature.layer.openPopup();
    }

    /**
     * Close
     */
    close(feature) {
        if (!feature) return;

        feature.layer.closePopup();
    }
}

export default new Popup();
